const ALLOWED_HTML_TAGS = [
  'b', 'strong', 'i', 'em', 'u', 's', 'strike',
  'mark', 'sup', 'sub', 'big', 'small',
  'p', 'br',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'a'
]
const BARE_TAGS_REGEX = new RegExp(`^</?(?:${ALLOWED_HTML_TAGS.join('|')})>$`, 'i')
const ANCHOR_OPEN_TAG_REGEX = /^<a\s+((?:href|target|rel|title)\s*=\s*"[^"]*"\s*)+>$/i
const HREF_VALUE_REGEX = /href\s*=\s*"([^"]*)"/i
const ALLOWED_HREF_SCHEME_REGEX = /^(https?:\/\/|mailto:|tel:|\/)/i
const ALL_TAGS_REGEX = /<\/?[^>]+>/g

function parseHtml(text) {
  if (typeof text !== 'string') return text
  text = text
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
  return text.replace(ALL_TAGS_REGEX, (match) => {
    if (BARE_TAGS_REGEX.test(match)) {
      return match
    }
    if (ANCHOR_OPEN_TAG_REGEX.test(match)) {
      const hrefMatch = match.match(HREF_VALUE_REGEX)
      if (!hrefMatch || ALLOWED_HREF_SCHEME_REGEX.test(hrefMatch[1])) {
        return match
      }
    }
    return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
  })
}